import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "d-flex gap-16 mb-8"
};
const _hoisted_2 = {
  class: "flex-1"
};
const _hoisted_3 = {
  class: "d-flex align-center"
};
const _hoisted_4 = {
  class: "flex-1"
};
const _hoisted_5 = {
  class: "d-flex align-center mb-3"
};
const _hoisted_6 = {
  class: "pl-8"
};
const _hoisted_7 = {
  key: 0,
  class: "mb-8"
};
const _hoisted_8 = {
  class: "d-flex align-center mb-3"
};
const _hoisted_9 = {
  class: "pl-8"
};
const _hoisted_10 = {
  class: "mb-2"
};
const _hoisted_11 = {
  class: "text-body-2 text-grey pl-8 mt-1"
};
const _hoisted_12 = {
  class: "d-flex gap-4"
};
const _hoisted_13 = {
  class: "flex-1"
};
const _hoisted_14 = {
  key: 0,
  class: "flex-1"
};
import { computed } from 'vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
export default {
  __name: 'AllocationOptions',
  props: {
    state: {
      type: Object,
      required: true
    }
  },
  emits: ['showOriginationStepDown', 'allocationMethodChange'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Computed property for dropdown options (excludes "all to responsible")
    const serviceAllocationOptions = computed(() => {
      const options = [{
        value: 'unallocatedToResponsible',
        label: `Allocate admin fees and unallocated fixed fees to responsible ${props.state.me.terms.lead}`
      }, {
        value: 'leaveUnallocated',
        label: 'Leave unallocated fees unallocated'
      }, {
        value: 'unallocatedToOriginating',
        label: `Allocate unallocated fixed fees to originating ${props.state.me.terms.lead}s`
      }];
      return options;
    });

    // Fixed fee allocation options for dropdown
    const fixedFeeAllocationOptions = computed(() => [{
      value: 'workedAmount',
      label: 'Worked amount'
    }, {
      value: 'workedHour',
      label: 'Worked hours'
    }, {
      value: 'percentage',
      label: 'Percentage'
    }]);

    // Selected value for ll-select (excludes checkbox option)
    const selectedServiceAllocation = computed({
      get() {
        if (props.state.form.chargesAttributedToResponsible) {
          return 'unallocatedToResponsible';
        } else if (props.state.form.unallocatedToOriginating) {
          return 'unallocatedToOriginating';
        }
        return 'leaveUnallocated';
      },
      set() {
        // Handled by handleServiceAllocationChange
      }
    });
    function handleAllToResponsibleChange(value) {
      if (value) {
        // When checkbox is checked, reset dropdown options
        props.state.form.chargesAttributedToResponsible = false;
        props.state.form.unallocatedToOriginating = false;
      }
    }
    function handleServiceAllocationChange(mode) {
      // Reset only dropdown-related options (don't touch servicesToResponsible)
      props.state.form.chargesAttributedToResponsible = false;
      props.state.form.unallocatedToOriginating = false;

      // Set the selected option from dropdown
      switch (mode) {
        case 'unallocatedToResponsible':
          props.state.form.chargesAttributedToResponsible = true;
          break;
        case 'unallocatedToOriginating':
          props.state.form.unallocatedToOriginating = true;
          break;
        case 'leaveUnallocated':
          // Both remain false
          break;
      }
    }
    function originationStepDownChange(state) {
      emit('showOriginationStepDown', state);
    }
    function handleAllocationMethodChange(method) {
      emit('allocationMethodChange', method);
    }
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_expand_transition = _resolveComponent("v-expand-transition");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_v_card, {
        class: "elevation-0 border"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "text-subtitle-1 font-weight-medium px-4 py-2 border-b"
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" Options ", -1)]))]),
          _: 1
        }), _createVNode(_component_v_card_text, {
          class: "pa-4"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(LlCheckbox, {
            modelValue: __props.state.form.creditsAsRevenue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => __props.state.form.creditsAsRevenue = $event),
            label: "Credits as revenue"
          }, null, 8, ["modelValue"]), _createVNode(LlTooltip, {
            icon: "help",
            class: "ml-2"
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Credit memos can be used for write-offs and so are not normally included in revenue allocation for attorneys. This option will allocate all credits as normal revenue. ", -1)]))]),
            _: 1
          })])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlCheckbox, {
            modelValue: __props.state.showOriginationStepDown,
            "onUpdate:modelValue": [_cache[1] || (_cache[1] = $event => __props.state.showOriginationStepDown = $event), originationStepDownChange],
            label: "Step down origination"
          }, null, 8, ["modelValue"]), _createVNode(LlTooltip, {
            icon: "help",
            class: "ml-2"
          }, {
            default: _withCtx(() => [_createTextVNode(" While Step-down is enabled, each " + _toDisplayString(__props.state.me.terms.Matter) + "'s origination will be allocated from payments made within the number of months listed here, based on that " + _toDisplayString(__props.state.me.terms.Matter) + "'s creation date. Any payment received after the step-down date will allocate 0% origination. ", 1)]),
            _: 1
          })]), _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_6, [_createVNode(LlTextField, {
              modelValue: __props.state.form.originationStepDownPeriodInMonths,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => __props.state.form.originationStepDownPeriodInMonths = $event),
              modelModifiers: {
                number: true
              },
              type: "number",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              suffix: "Months",
              style: {
                "max-width": "340px"
              }
            }, null, 8, ["modelValue"])], 512), [[_vShow, __props.state.showOriginationStepDown]])]),
            _: 1
          })])]), __props.state.me.features.recentDateCompOption ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(LlCheckbox, {
            modelValue: __props.state.form.useMostRecentDate,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => __props.state.form.useMostRecentDate = $event),
            label: "Use invoice date if later than payment"
          }, null, 8, ["modelValue"]), _createVNode(LlTooltip, {
            icon: "help",
            class: "ml-2"
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" When enabled, revenue is recognized on the date of the invoice if the invoice is dated later than the payment. ", -1)]))]),
            _: 1
          })]), _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_9, [_createVNode(LlDatePicker, {
              modelValue: __props.state.form.useMostRecentDateCutoff,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => __props.state.form.useMostRecentDateCutoff = $event),
              label: "From",
              "hide-details": "",
              style: {
                "max-width": "340px"
              }
            }, null, 8, ["modelValue"]), _cache[11] || (_cache[11] = _createElementVNode("div", {
              class: "text-body-2 text-grey mt-1"
            }, " Only for payments dated after this date ", -1))], 512), [[_vShow, __props.state.form.useMostRecentDate]])]),
            _: 1
          })])) : _createCommentVNode("", true), _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1)), _createElementVNode("div", _hoisted_10, [_createVNode(LlCheckbox, {
            modelValue: __props.state.form.servicesToResponsible,
            "onUpdate:modelValue": [_cache[5] || (_cache[5] = $event => __props.state.form.servicesToResponsible = $event), handleAllToResponsibleChange],
            label: `Responsible ${__props.state.me.terms.lead} receives worked share of services`
          }, null, 8, ["modelValue", "label"]), _createElementVNode("div", _hoisted_11, " All worked share goes to the responsible " + _toDisplayString(__props.state.me.terms.lead) + ". Does not affect originating " + _toDisplayString(__props.state.me.terms.lead) + " or firm share allocations. ", 1)]), _cache[13] || (_cache[13] = _createElementVNode("div", {
            class: "d-flex align-center mb-2"
          }, [_createElementVNode("hr", {
            class: "flex-grow-1 border-0 border-t border-gray-300"
          }), _createElementVNode("span", {
            class: "text-body-2 text-grey font-italic px-4"
          }, " SET FIXED FEE ALLOCATION DEFAULTS AND HANDLING FOR ADMIN FEES OR UNASSIGNED REVENUE "), _createElementVNode("hr", {
            class: "flex-grow-1 border-0 border-t border-gray-300"
          })], -1)), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(LlSelect, {
            modelValue: selectedServiceAllocation.value,
            "onUpdate:modelValue": [_cache[6] || (_cache[6] = $event => selectedServiceAllocation.value = $event), handleServiceAllocationChange],
            items: serviceAllocationOptions.value,
            label: "How to handle unallocated fixed/admin fees:",
            "item-title": "label",
            "item-value": "value",
            "return-object": false,
            horizontal: false,
            disabled: __props.state.form.servicesToResponsible,
            info: "This setting determines where unallocated fixed or administrative fees are distributed",
            "show-info": true
          }, null, 8, ["modelValue", "items", "disabled"])]), __props.state.me.features.fixedFeeAllocation ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(LlSelect, {
            modelValue: __props.state.form.fixedFeeAllocationMode,
            "onUpdate:modelValue": [_cache[7] || (_cache[7] = $event => __props.state.form.fixedFeeAllocationMode = $event), handleAllocationMethodChange],
            items: fixedFeeAllocationOptions.value,
            label: "Fixed Fee Allocation Default",
            "item-title": "label",
            "item-value": "value",
            "return-object": false,
            horizontal: false,
            disabled: __props.state.form.servicesToResponsible,
            info: "Set the default allocation method for all new fixed fees",
            "show-info": true
          }, null, 8, ["modelValue", "items", "disabled"])])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};